import  { useEffect, useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import {
  getNotificationsApi,
  markNotificationReadApi,
  markAllNotificationsReadApi,
  getUnreadCountApi
} from "../../api/apiUrlConst";
import { startSignalRConnection } from "../../service/signalrService";
import logo from "../../assets/images/wocons.png";
import LogoutIcon from '@mui/icons-material/Logout';

function NavHeader() {
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const toggle = () => setIsOpen(!isOpen);
  const toggleDropdown = () => setDropdownOpen(prev => !prev);

  const { token, name,role, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const isDark = theme === "dark";


  

  useEffect(() => {
    if (token) {
      loadNotifications();
      loadUnreadCount();
      initSignalR();
    }
  }, [token]);

  const initSignalR = async () => {
    const conn = await startSignalRConnection();
    if (!conn) return;

    conn.on("ReceiveNotification", (notification) => {
      setNotifications(prev => [notification, ...prev]);
      setUnreadCount(prev => prev + 1);
    });
  };

  const loadNotifications = async () => {
    const data = await getNotificationsApi();
    setNotifications(data);
  };

  const loadUnreadCount = async () => {
    const data = await getUnreadCountApi();
    setUnreadCount(data.unreadCount);
  };

  const handleMarkRead = async (id: number) => {
    await markNotificationReadApi(id);

    setNotifications(prev =>
      prev.map(n =>
        n.id === id ? { ...n, isRead: true } : n
      )
    );

    setUnreadCount(prev => (prev > 0 ? prev - 1 : 0));
  };

  const handleMarkAllRead = async () => {
    await markAllNotificationsReadApi();

    setNotifications(prev =>
      prev.map(n => ({ ...n, isRead: true }))
    );

    setUnreadCount(0);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
<Navbar
  fixed="top"
  expand="md"
  className="px-4 py-2 shadow-sm"
  style={{
    background: token
      ? "linear-gradient(90deg, #1f2937)"
      : "#ffffff",
    color: token ? "#ffffff" : "inherit"
  }}
>
      <NavbarBrand href="/" className="d-flex align-items-center">
        <img src={logo} alt="Wocons Logo" style={{ height: "45px" }} />
      </NavbarBrand>

      <NavbarToggler onClick={toggle} />

      <Collapse isOpen={isOpen} navbar>
        <Nav className="ms-auto align-items-center gap-3" navbar>

          {!token && (
            <>
              <NavItem>
                <NavLink className="nav-link-custom" href="/">
                  Home
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="nav-link-custom" href="#services-section">
                  Services
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="nav-link-custom" href="#success-stories-section">
                  Success Stories
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="nav-link-custom" href="#solutions-section">
                  Solutions
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="nav-link-custom" href="#about-section">
                  About Us
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="nav-link-custom" href="#about-section">
                  Mission
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="nav-link-custom" href="https://feesworth.com/" target="_blank">
                  Training
                </NavLink>
              </NavItem>
              <NavItem>
                <a href="/contact" className="quote-btn ms-3">
                  Contact us
                </a>
              </NavItem>
              <NavItem>
                <a href="/login" className="quote-btn2 ms-3">
                  Login
                </a>
              </NavItem>
            </>
          )}

          {token && (
            <>
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle caret color="light" size="sm">
                  🔔
                  {unreadCount > 0 && (
                    <Badge color="danger" pill className="ms-2">
                      {unreadCount}
                    </Badge>
                  )}
                </DropdownToggle>

                <DropdownMenu
                  end={false}
                  style={{
                    width: "320px",
                    maxHeight: "400px",
                    overflowY: "auto",
                    right: 0,
                    left: "auto"
                  }}
                >
                  <div className="d-flex justify-content-between px-3 py-2 border-bottom">
                    <strong>Notifications</strong>
                    {unreadCount > 0 && (
                      <span
                        style={{ cursor: "pointer", fontSize: "12px" }}
                        onClick={handleMarkAllRead}
                      >
                        Mark all as read
                      </span>
                    )}
                  </div>

                  {notifications.length === 0 && (
                    <DropdownItem>No notifications</DropdownItem>
                  )}

                  {notifications.map((n) => (
                    <DropdownItem
                      key={n.id}
                      onClick={() => handleMarkRead(n.id)}
                      style={{
                        backgroundColor: n.isRead
                          ? "transparent"
                          : isDark
                            ? "#2a2a2a"
                            : "#f8f9fa"
                      }}
                    >
                      <div style={{ fontWeight: 600 }}>
                        {n.title}
                      </div>
                      <div style={{ fontSize: "12px" }}>
                        {n.message}
                      </div>
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>

             <NavItem className="me-3 d-flex align-items-center gap-2">

  {/* Avatar */}
  <div
    className="d-flex align-items-center justify-content-center"
    style={{
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      background: "#ffffff",
      color: "#374151",
      fontWeight: 700,
      fontSize: "16px"
    }}
  >
    {name?.charAt(0).toUpperCase()}
  </div>

  {/* Name + Role */}

<div style={{ lineHeight: "1" }}>
  <Badge
    pill
    style={{
      background: "linear-gradient(90deg,#374151,#093d92)",
      fontSize: "11px",
      padding: "4px 8px",
      fontWeight: 600
    }}
  >
    {role}
  </Badge>
</div>

</NavItem>

              
              <NavItem>
                <Button
                  color="danger"
                  size="sm"
                  onClick={handleLogout}
                >
                 <LogoutIcon /> Logout
                </Button>
              </NavItem>
            </>
          )}
        </Nav>
      </Collapse>
    </Navbar>
  );
}

export default NavHeader;